// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"features-list_imageContainer__keAj1"};